import React from 'react';
import DoorOverlay from './DoorOverlay';
import { useLanguage } from '../context/LanguageContext';

const SectionCard = ({ id, icon, title, subtitle, children, isDoorOpen }) => {
  const { t } = useLanguage();
  const doorInfo = t.door[id] || { title: 'Section', message: 'Welcome' };
  
  return (
    <section id={id} className={`section-card ${isDoorOpen ? 'door-opening' : ''}`}>
      <DoorOverlay 
        title={doorInfo.title} 
        message={doorInfo.message} 
        isOpen={isDoorOpen}
      />
      <h2>
        <span className="section-icon">{icon}</span>
        {title}
      </h2>
      {subtitle && <p className="subtitle">{subtitle}</p>}
      {children}
    </section>
  );
};

export default SectionCard;
